var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeaksMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00527c;\n      }\n\n      .cls-2 {\n        fill: #2ebee4;\n      }\n\n      .cls-3 {\n        fill: #1a98c2;\n      }\n\n      .cls-4 {\n        fill: #0a74a0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visual"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,593l120,27,120-81,120,144,120-9,120-72v298H0v-307Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,449h120l120-18,120,90,120-27,120-54v163l-120,72-120,9-120-144-120,81L0,594v-145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m0,188l120-9,120-45,120,45,120,36,120-90v316l-120,54-120,27-120-90-120,18H0V188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,0h600v126l-120,90-120-36-120-45-120,45L0,189V0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaksMobile);
export default __webpack_public_path__ + "static/media/peaks_mobile.99875d628c13b17eabaf67733617e90f.svg";
export { ForwardRef as ReactComponent };